import { useConfig } from '../../../hooks/use-config'
import { getConfigValue } from '../../../utils/getConfigValue'

/**
 * fetch search related configration from config query
 */
export const useGetSearchConfig = () => {
  const { appConfig } = useConfig()
  const values = appConfig.values
  const minChar = getConfigValue(values, 'SEARCH_TRIGGER_MIN_CHAR') || 2
  const debounceMilliSec = getConfigValue(values, 'SEARCH_TRIGGER_DEBOUNCE_MILLI_SEC') || 500
  return {
    minChar, // min characters to trigger search req
    debounceMilliSec // search input changes within this period will be debounced
  }
}
